import React from 'react';
import '../styles/components/Cookies.css';
import cookieIcon from '../assets/icons-main/icon-cookies.svg';

export default class Cookies extends React.Component {
    constructor(props) {
        super(props)
        this.getCookie = this.getCookie.bind(this);
        this.setCookie = this.setCookie.bind(this);
        this.state = {
            cookieVisible: false
        }
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie(cookieName, cookieValue, expireDays) {
        var date = new Date();
        date.setTime(date.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + "; " + expires;
    }

    componentDidMount() {
        if (this.getCookie("cookieInfo") === "agreed") {
            this.setState({
                cookieVisible: false
            })
        } else {
            this.setState({
                cookieVisible: true
            })
        }
    }

    render() {
        if (this.state.cookieVisible) {
            return (
                <div id="cookieInfo" className="cookie__wrapper">
                    <div className="cookie__container container">
                        <img className="svg" style={{display: 'none'}} src={cookieIcon} alt="Cookies" title="Cookies" />
                        <p>Korzystamy z plików cookies i umożliwiamy zamieszczanie ich osobom trzecim. Pliki cookie pozwalają na poznanie Twoich preferencji na podstawie
                            zachowań na stronie. Kontynuując korzystanie z serwisu, wyrażasz na to zgodę. Poznaj szczegóły i możliwości zmiany ustawień w <a href="/">Polityce Cookies.</a></p>
                        <button id="cookieBtn" className="btn-general btn-general--white" onClick={() => {
                            this.setCookie("cookieInfo", "agreed", 360);
                            this.setState({
                                cookieVisible: false
                            })
                        }}>Akceptuję</button>
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}
